import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { makeMainLayout } from '@/layouts/main'
import {
  layoutConfig,
  StatePage,
  translationNamespaces
} from '@/features/States'

const State = () => {
  return <StatePage alphaCode="MB" />
}

export const getStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, translationNamespaces))
    }
  }
}

State.Layout = makeMainLayout(layoutConfig)

export default State
